import { Box } from "@material-ui/core";
import { SnackbarProvider } from "notistack";
import { createRef } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import LayoutWrapper from "src/components/wrapper/LayoutWrapper";
import ThemeWrapper from "src/components/wrapper/ThemeWrapper";
import store from "src/redux/store";
import RouteApp from "./RouteApp";

export default function Root() {
  const notistackRef = createRef();

  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <Provider store={store}>
      <Router>
        <ThemeWrapper>
          <SnackbarProvider
            maxSnack={3}
            ref={notistackRef}
            action={(key) => (
              <Box
                style={{ color: "rgba(255, 255, 255, 0.8)", cursor: "pointer", padding: "0px 8px" }}
                onClick={onClickDismiss(key)}
              >
                Dismiss
              </Box>
            )}
          >
            <LayoutWrapper>
              <RouteApp />
            </LayoutWrapper>
          </SnackbarProvider>
        </ThemeWrapper>
      </Router>
    </Provider>
  );
}
